import { render, staticRenderFns } from "./RealEstateClientView.vue?vue&type=template&id=3fc37ea3&"
import script from "./RealEstateClientView.vue?vue&type=script&lang=js&"
export * from "./RealEstateClientView.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateClientView.vue?vue&type=style&index=0&id=3fc37ea3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports